/**
 * Candidate oceanic data center sites on the West Coast.
 * Coordinates are representative coastal points.
 * SST ranges are screening-level climatological bands from NOAA CoastWatch products.
 */
const CANDIDATE_SITES = [
  {
    id: "sf-bay",
    name: "San Francisco Bay",
    lat: 37.78,
    lng: -122.42,
    region: "Bay Area, CA",
    summerSST: "14-18C",
    winterSST: "10-13C",
    keySpecies: ["Chinook", "Eelgrass", "Pacific Herring", "Dungeness Crab"],
    regulatoryNote: "BCDC/SF Bay permitting context. CA Thermal Plan caps enclosed-bay thermal increases at 4F (2.2C).",
    riskLevel: "CRITICAL",
    vulnerabilities: ["17% of CA eelgrass", "Herring spawning", "Shallow, low dilution", "Toxic algae bloom risk"],
  },
  {
    id: "puget-sound",
    name: "Puget Sound",
    lat: 47.6,
    lng: -122.4,
    region: "Washington",
    summerSST: "12-15C",
    winterSST: "7-9C",
    keySpecies: ["Chinook", "Coho", "SRKW", "Eelgrass", "Bull Kelp"],
    regulatoryNote: "WAC 173-201A limits cumulative human warming to 0.3C near criteria.",
    riskLevel: "HIGH",
    vulnerabilities: ["22,800 ha eelgrass", "SRKW critical habitat", "Hood Canal hypoxia", "0.3C incremental limit"],
  },
  {
    id: "salish-sea",
    name: "Salish Sea / BC",
    lat: 48.85,
    lng: -123.3,
    region: "British Columbia",
    summerSST: "10-14C",
    winterSST: "5-8C",
    keySpecies: ["Chinook", "Sockeye", "SRKW", "Bull Kelp", "Eelgrass"],
    regulatoryNote: "Fisheries Act s.36 prohibition applies to deleterious deposit; CCME marine guideline is +/-1C.",
    riskLevel: "HIGH",
    vulnerabilities: ["No thermal variance pathway", "SRKW critical habitat", "Bull kelp at thermal limits", "First Nations rights"],
  },
  {
    id: "monterey",
    name: "Monterey Bay",
    lat: 36.8,
    lng: -121.9,
    region: "California",
    summerSST: "12-16C",
    winterSST: "10-13C",
    keySpecies: ["Chinook", "Leatherback Turtle", "Sea Otters", "Bull Kelp"],
    regulatoryNote: "Monterey Bay National Marine Sanctuary protections apply; CA thermal constraints still govern discharges.",
    riskLevel: "CRITICAL",
    vulnerabilities: ["National Marine Sanctuary", "Leatherback critical habitat", "Kelp forest ecosystem", "Upwelling zone"],
  },
  {
    id: "columbia-river",
    name: "Columbia River Estuary",
    lat: 46.25,
    lng: -124.05,
    region: "Oregon/Washington",
    summerSST: "15-21C",
    winterSST: "5-8C",
    keySpecies: ["Chinook", "Coho", "Sockeye", "Steelhead", "Chum"],
    regulatoryNote: "OR and WA criteria include 0.3C incremental protection in cold-water contexts.",
    riskLevel: "HIGH",
    vulnerabilities: ["Major salmon migration corridor", "Already near thermal limits", "Multiple ESA ESUs", "Cumulative dam effects"],
  },
];

/** @deprecated import DATA_FEED_ENDPOINTS from "../config/dataSources" — kept for map panel copy */
export { DATA_FEED_ENDPOINTS as DATA_SOURCES } from "../config/dataSources";

export const PLUME_DEFAULTS = { powerMW: 1, dischargeTemp: 5, currentSpeed: 0.15, ambientTemp: 12, depth: 30 };

export default CANDIDATE_SITES;
